import JsonApi from "./jsonApi";
import {renderErrorPopup} from "./api-popups";
import {loaderDisable} from "../bvcomponents/ui/loaderView";
import {restorePaymentInfo} from "../actions/paymentFunctions";
import Misc from "../misc/misc";

export const postDealerShipToAddress = () => {
  return async (dispatch, getState) => {
    const store = getState();
    const {shippingAddress} = store.paymentState;
    const postData = {
      "jobId": document.kvConfig.jobId,
      "name": shippingAddress.fullName,
      "address1": shippingAddress.address1,
      "address2": shippingAddress.address2,
      "city": shippingAddress.city,
      "state": shippingAddress.state,
      "zip": shippingAddress.postal,
      "country": shippingAddress.country,
    };
    return JsonApi.setShipToAddress(postData)
      .then(response => response.data)
      .catch(error => {
        renderErrorPopup((error && error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : "Server "+new Error(error));
        loaderDisable();
        // dispatch({
        //   type: types.CHANGE_SELECTION_ACTIVE_PART_RELATED_INDEX,
        //   payload: {
        //     activePartRelatedItemIndex: newActivePartRelatedItemIndex,
        //     isSameStep: newActivePartRelatedItemIndex === activePartRelatedItemIndex
        //   }
        // });
        return error
      })
  }
}

export const getDealerShipToAddress = () => {
  return async (dispatch) => {
    return JsonApi.getShipToAddress()
      .then(response => {
        if (!response || !response.data || response.error || response.data.error) {
          return
        }
        dispatch(restorePaymentInfo(Misc.parseShippingAndBillingResponse({
          shippingAddress: response.data,
        })))
      })
      .catch(error => error)
  }
}
